export default __webpack_public_path__ + "static/media/media__item-img-9.b32e7e83.png";